import { useState } from "react";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Logo from "../../assets/images/logo.png";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

// import {
//   _set_token_in_localStorage,
//   _set_user_in_localStorage,
// } from "../local_storage/local_storage";
import { useSnackbar } from "notistack";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { email_verification_api } from "../../DAL/adminAuth/auth";

export default function ForGotPassword() {
  //   const { setUserInfo } = useAdminContext();
  const { enqueueSnackbar } = useSnackbar();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [inputs, setInputs] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const forgot_post_data = {
      email: inputs.email,
    };
    setIsLoading(true);
    const response = await email_verification_api(forgot_post_data);
    console.log(response, "responseresponseresponse");
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      navigate("/verification-code", {
        state: {
          email: inputs.email,
          verification_code: response?.verification_code,
        },
      });
      setIsLoading(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  return (
    <div className="pageContainer">
      <div className="form-container">
        <div className="form-content">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "16px",
              fontWeight: 500,
              fontFamily: "Montserrat, sans-serif",
            }}
          >
            <ArrowBackIcon
              onClick={() => navigate("/")}
              fontSize="small"
              sx={{
                mr: 1,
                backgroundColor: "black",
                color: "white",
                borderRadius: "50%", // makes it circular
                padding: "6px", // adjust to balance the circle
                fontSize: "31px", // increased icon size
                cursor: "pointer",
              }}
            />
            Back to Login
          </div>
          <h2 className="sign-in-title mb-3">Forgot Password?</h2>
          <p>Enter your email and we’ll help you reset your password.</p>
          <form onSubmit={handleSubmit} className="form">
            <div className="mt-3">
              <TextField
                fullWidth
                required
                label="Email"
                name="email"
                type="email"
                value={inputs.email}
                onChange={handleChange}
              />
            </div>

            <div className="forgot-password-container mt-2"></div>
            <Button
              type="submit"
              className="mui-button"
              disabled={isLoading}
              variant="contained"
              fullWidth
            >
              {isLoading ? "loading..." : "Reset Password"}
            </Button>
          </form>
        </div>
      </div>
      <div className="logoContainer">
        <div className="logoContent">
          <img src={Logo} alt="new" className="logoImage" />
          <h2 className="logoTitle">Welcome, Admin</h2>
          <p>Manage your community and users effectively.</p>
        </div>
      </div>
    </div>
  );
}
